import { render, staticRenderFns } from "./ElementsListWidget.vue?vue&type=template&id=78d40d96&scoped=true"
import script from "./ElementsListWidget.vue?vue&type=script&lang=js"
export * from "./ElementsListWidget.vue?vue&type=script&lang=js"
import style0 from "./ElementsListWidget.vue?vue&type=style&index=0&id=78d40d96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d40d96",
  null
  
)

export default component.exports